import { useState } from 'react';

export function VideoThumbnail() {
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl text-[#1F473E] mb-4">
            Experience Our Space
          </h2>
          <p className="text-lg text-[#49685E]">
            Take a virtual tour of our premium coworking facilities
          </p>
        </div>
        
        <div className="relative rounded-lg overflow-hidden shadow-2xl h-[300px] md:h-[400px]">
          {!isPlaying ? (
            <div className="relative cursor-pointer h-full" onClick={handlePlay}>
              <video
                className="w-full h-full object-cover"
                poster="https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/home/dashboard/MainEntrance.jpeg"
              >
                <source src="https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/home/dashboard/coworking_video.mp4" type="video/mp4" />
              </video>
              <div className="absolute inset-0 flex items-center justify-center bg-black/20">
                <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors">
                  <div className="w-0 h-0 border-l-[12px] border-l-[#1F473E] border-t-[8px] border-t-transparent border-b-[8px] border-b-transparent ml-1"></div>
                </div>
              </div>
            </div>
          ) : (
            <video
              className="w-full h-full object-cover"
              controls
              autoPlay
            >
              <source src="https://pub-0a73c6fd83b94478ade039aa11d5ad47.r2.dev/home/dashboard/coworking_video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}
        </div>
      </div>
    </section>
  );
}